module.exports = __webpack_public_path__ + "img/close.94ca46cd.svg";